
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import State from '../State';
import MeasurementSpecificationTemplateEditor from './MeasurementSpecificationTemplateEditor';
import Spinner from '../../util/Spinner';
import { MeasurementSpecificationTemplate, TestEquipmentMeasurementSpecificationTemplatesUiV2Client } from '../../backend/backendapi';
import { handleError, initClient } from '../../../api';
import { emptyUUID } from '../../../util';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    MeasurementSpecificationTemplateEditor,
    Spinner,
  },
})
export default class MeasurementSpecificationTemplateEditModal extends Vue {
  @Prop({ default: true })
  readonly editable!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  readonly api = initClient(TestEquipmentMeasurementSpecificationTemplatesUiV2Client);
  saving = false;
  template: MeasurementSpecificationTemplate | null = null;

  get canSave(): boolean {
    return !!this.template
        && !!this.template.name;
  }

  public open(template: MeasurementSpecificationTemplate): void {
    this.template = MeasurementSpecificationTemplate.fromJS(template); //deep copy so original is not modified
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.template = null;
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    if (!this.template) {
      return;
    }

    this.saving = true;
    try {
      let template: MeasurementSpecificationTemplate;
      if (!this.template.id || this.template.id === emptyUUID()) {
        template = (await this.api.create([this.template]))[0];
      } else {
        template = await this.api.update(this.template.id, this.template);
      }
      this.$toasted.info(this.$t('txtSaved').toString());
      this.state.templatesStore.rememberTemplate(template);
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
